import React, { useState, useEffect, forwardRef } from "react";
import Modal from "react-bootstrap/Modal";
import "./ViewportCenteredModal.scss";
import DatePicker from "react-datepicker";
import { AutoSuggest } from "./AutoSuggest";
import ValidateProject from "../../validation/ValidateNewProject";
import { CheckNull } from "../../utils/Validate";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import FetchData, { CreateEntry, GetList } from "../../providers/dataProvider";
import {
  SuccessMessages,
  ErrorMessages,
} from "../../constants/MessageConstants";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import urls from "../../constants";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import def from "ajv/dist/vocabularies/discriminator";

const modalContainer =
  typeof document !== "undefined" ? document.body : undefined;

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    onChange={onChange}
    ref={ref}
    placeholder="DD/MM/YYYY"
  ></input>
));
// datepicker end

export default function AddToProjectModal({
  setShowNewProj,
  showNewProj,
  projectData,
  customerData,
  pageName,
  countryData,
  distributordata,
  projectLists,
  setProjectData,
  setProjectName,
  selectedDistributor
}) {
  const defaultValues = {
    projectCode: "N",
    projectName: "",
    projectSegmentId: 0,
    projectStatusId: 0,
    mainContractorId: "",
    mepContractorId: "",
    designConultantId: "",
    supervisionConsultantId: "",
    clientId: "",
    distributorId: "",
    countryId: 0,
    startDate: new Date(),
    endDate: new Date(),
    additionalInfo: "",
    createdBy: localStorage.getItem("authidentity"),
    projectContacts: [],
    subContractors: [],
  };

  const [mepPrjCustomerDrp, setMEPPrjCustomerdrp] = useState([]);
  const [mainCustomerDrp, setMainCustomerdrp] = useState([]);
  const [designCustomerDrp, setDesignCustomerdrp] = useState([]);
  const [superCustomerDrp, setSuperCustomerdrp] = useState([]);
  const [clientCustomerDrp, setClientCustomerdrp] = useState([]);

  const [prjSegment, setprjSegment] = useState(null);
  const [prjStatus, setprjStatus] = useState(null);
  const [prjmepCust, setprjmepCust] = useState(null);
  const [prjmainCust, setprjMainCust] = useState(null);
  const [prjDesignCust, setprjDesignCust] = useState(null);
  const [prjSuperCust, setprjSuperCust] = useState(null);
  const [prjClientCust, setprjClientCust] = useState(null);
  const [prjDistributorCust, setprjDistCust] = useState(null);
  const [prjCountry, setprjCountry] = useState(null);

  const [formValues, setFormValues] = useState(defaultValues);
  const [formErrors, setFormError] = useState({});
  const [projectList, setProjectList] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [createMsg, setCreateMsg] = useState(null);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: "",
  });
  const [show, setShow] = useState(false);
  const [prjEndDate, setprjEndDate] = useState(new Date());
  const {
    data: projectsegment,
    loading: prjSegLoading,
    error: prjSegError,
  } = FetchData("projectsegment");
  const {
    data: projectstatus,
    loading: prjstaLoading,
    error: prjstaError,
  } = FetchData("projectstatus");

  const HandleFormChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value || "",
    });

    const errors = ValidateProject({
      ...formValues,
      [name]: value,
    });

    setFormError({
      ...formErrors,
      [name]: errors[name],
    });
  };

  useEffect(() => {
    setFormValues({
      ...formValues,
      endDate: prjEndDate,
    });
  }, [prjEndDate]);

  const HandleDropDownChange = (selectedOption, params) => {
    setFormValues({
      ...formValues,
      [params]: selectedOption?.value || "",
    });

    const errors = ValidateProject({
      ...formValues,
      [params]: selectedOption?.value,
    });

    setFormError({
      ...formErrors,
      [params]: errors[params],
    });
  };

  useEffect(() => {
    if (selectedDistributor) {
      setFormValues({
        ...defaultValues,
        distributorId: selectedDistributor?.value,
        countryId: distributordata?.find(item => item.id === selectedDistributor?.value)?.countryId
      })
      setFormError({})
    }
  }, [selectedDistributor, showNewProj, distributordata])

  useEffect(() => {
    const getCustomerData = () => {
      if (customerData) {
        const MEPcusttype = customerData.filter((item) =>
          item.type.includes(urls.MEP_CUSTOMER)
        );
        setMEPPrjCustomerdrp(MEPcusttype);

        const Maincusttype = customerData.filter((item) =>
          item.type.includes(urls.MAIN_CUSTOMER)
        );
        setMainCustomerdrp(Maincusttype);

        const Designcusttype = customerData.filter((item) =>
          item.type.includes(urls.DESIGN_CONSULTANT_CUSTOMER)
        );
        setDesignCustomerdrp(Designcusttype);

        const Supercusttype = customerData.filter((item) =>
          item.type.includes(urls.SUPER_VISION_CONSULTANT_CUSTOMER)
        );
        setSuperCustomerdrp(Supercusttype);

        const Clientcusttype = customerData.filter((item) =>
          item.type.includes(urls.CLIENT_CUSTOMER)
        );
        setClientCustomerdrp(Clientcusttype);
      }
    };
    getCustomerData();
  }, [customerData]);

  useEffect(() => {
    const getprojectData = () => {
      if (projectLists) {
        const list = formatprojectData(projectLists);
        setProjectList(list);
      }
    };
    getprojectData();
  }, [projectLists]);

  const formatprojectData = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.projectName,
      value: data?.id,
    }));
    return te;
  };

  const HandleFormSubmit = (event) => {
    event.preventDefault();
    setFormError(ValidateProject(formValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      CreateEntry(
        "project",
        formValues,
        setCreateMsg,
        "Project created successfully",
        "Failed to create project"
      );
      setDisabledSubmit(true);
      setFormError({});
    }
    setIsSubmit(false);
  }, [formErrors]);

  useEffect(() => {
    if (CheckNull(createMsg?.message).includes("Failed")) {
      setDisabledSubmit(false);
      let errorsmsg = createMsg.successData;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
    } else if (CheckNull(createMsg?.status) == 200) {
      const dt = createMsg?.successData;
      const newItem = {
        ...dt,
        label: dt?.projectName,
        value: dt?.id,
      };
      setProjectData([...projectData, newItem]);
      setProjectName(newItem);
      setShowNewProj(false);
      setShow(true);
      setDisabledSubmit(false);
    }
  }, [createMsg]);

  const SuccessDoneClick = () => {
    setShow(false);
    setShowNewProj(false);
    return;
  };

  const handleCancelNewProject = () => {
    setShowNewProj(false);
    setFormValues({});
  };

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  return (
    <div>
      <Modal
        show={showNewProj}
        centered
        size="xl"
        className="addToProjectMasterPopModal"
        dialogClassName="viewport-centered-modal-dialog"
        container={modalContainer}
      >
        <Modal.Header>
          <h5 className="modal-title">Add New Project</h5>
          <i className="fas fa-times" onClick={handleCancelNewProject}></i>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Project Name <span className="mandatory">*</span>
                </label>
                <AutoSuggest
                  options={projectList}
                  setStateValue={setFormValues}
                  stateValue={formValues}
                  placeholder="Enter project name"
                  params="projectName"
                  className="form-control"
                />
                <p className="form-error">{formErrors?.projectName}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Distributor <span className="mandatory">*</span>
                </label>
                <DropDownComponent
                  isDisabled={["Enquiry", "jobinhand"].includes(pageName) ? true : false}
                  placeHolder={PlaceHolder.SELECT_DISTRIBUTOR}
                  pageName="project"
                  dpDownName="distributor"
                  stateData={distributordata}
                  controlName="distributordrp"
                  handleChange={(e) => {
                    HandleDropDownChange(e, "distributorId");
                  }}
                  value={prjDistributorCust}
                  valueId={formValues?.distributorId}
                  setState={setprjDistCust}
                />
                {formErrors?.distributorId && (
                  <p className="form-error">{formErrors?.distributorId}</p>
                )}
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Country <span className="mandatory">*</span>{" "}
                </label>
                <DropDownComponent
                  isDisabled={["Enquiry", "jobinhand"].includes(pageName) ? true : false}
                  placeHolder={PlaceHolder.SELECT_COUNTRY}
                  pageName="project"
                  dpDownName="country"
                  stateData={countryData}
                  controlName="countrydrp"
                  handleChange={(e) => {
                    HandleDropDownChange(e, "countryId");
                  }}
                  value={prjCountry}
                  valueId={formValues?.countryId}
                  setState={setprjCountry}
                />
                <p className="form-error">{formErrors?.countryId}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Client</label>
                <DropDownComponent
                  placeHolder={PlaceHolder.SELECT_CLIENT}
                  pageName="project"
                  dpDownName="customer"
                  stateData={clientCustomerDrp}
                  controlName="Clientcustomerdrp"
                  handleChange={(e) => {
                    HandleDropDownChange(e, "clientId");
                  }}
                  value={prjClientCust}
                  valueId={formValues?.clientId}
                  setState={setprjClientCust}
                />
                <p className="form-error">{formErrors?.clientId}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>MEP Contractor</label>
                <DropDownComponent
                  placeHolder={PlaceHolder.SELECT_MEP_CUSTOMER}
                  pageName="project"
                  dpDownName="customer"
                  stateData={mepPrjCustomerDrp}
                  controlName="MEPPrjcustomerdrp"
                  handleChange={(e) => {
                    HandleDropDownChange(e, "mepContractorId");
                  }}
                  value={prjmepCust}
                  valueId={formValues?.mepContractorId}
                  setState={setprjmepCust}
                />
                <p className="form-error">{formErrors?.mepContractorId}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Design Consultant</label>
                <DropDownComponent
                  placeHolder={PlaceHolder.SELECT_DESIGN_CONSULTANT}
                  pageName="project"
                  dpDownName="customer"
                  stateData={designCustomerDrp}
                  controlName="Designcustomerdrp"
                  handleChange={(e) => {
                    HandleDropDownChange(e, "designConultantId");
                  }}
                  value={prjDesignCust}
                  valueId={formValues?.designConultantId}
                  setState={setprjDesignCust}
                />
                <p className="form-error">{formErrors?.designConultantId}</p>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Main Contractor <span className="mandatory">*</span></label>
                <DropDownComponent
                  placeHolder={PlaceHolder.SELECT_MAIN_CUSTOMER}
                  pageName="project"
                  dpDownName="customer"
                  stateData={mainCustomerDrp}
                  controlName="Maincustomerdrp"
                  handleChange={(e) => {
                    HandleDropDownChange(e, "mainContractorId");
                  }}
                  value={prjmainCust}
                  valueId={formValues?.mainContractorId}
                  setState={setprjMainCust}
                />
                <p className="form-error">{formErrors?.mainContractorId}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Project Segment <span className="mandatory">*</span></label>
                <DropDownComponent
                  placeHolder={PlaceHolder.SELECT_SEGMENT}
                  pageName="project"
                  dpDownName="projectsegment"
                  stateData={projectsegment}
                  controlName="prjSegdrp"
                  handleChange={(e) => {
                    HandleDropDownChange(e, "projectSegmentId");
                  }}
                  value={prjSegment}
                  valueId={formValues?.projectSegmentId}
                  setState={setprjSegment}
                />
                <p className="form-error">{formErrors?.projectSegmentId}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Project Status <span className="mandatory">*</span></label>
                <DropDownComponent
                  placeHolder={PlaceHolder.SELECT_STATUS}
                  pageName="project"
                  dpDownName="projectstatus"
                  stateData={projectstatus}
                  controlName="prjStadrp"
                  handleChange={(e) => {
                    HandleDropDownChange(e, "projectStatusId");
                  }}
                  value={prjStatus}
                  valueId={formValues?.projectStatusId}
                  setState={setprjStatus}
                />
                <p className="form-error">{formErrors?.projectStatusId}</p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Supervision Consultant</label>
                <DropDownComponent
                  placeHolder={PlaceHolder.SELECT_SUPER_CONSULTANT}
                  pageName="project"
                  dpDownName="customer"
                  stateData={superCustomerDrp}
                  controlName="Supercustomerdrp"
                  handleChange={(e) => {
                    HandleDropDownChange(e, "supervisionConsultantId");
                  }}
                  value={prjSuperCust}
                  valueId={formValues?.supervisionConsultantId}
                  setState={setprjSuperCust}
                />
                <p className="form-error">
                  {formErrors?.superVisionConsultantId}
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Expected Completion Date <span className="mandatory">*</span></label>
                <DatePicker
                  name="endDate"
                  selected={formValues?.endDate}
                  onChange={(date) => setprjEndDate(date)}
                  customInput={<ExampleCustomInput />}
                  dayClassName={() => "example-datepicker-day-class"}
                  popperClassName="example-datepicker-class"
                  todayButton="TODAY"
                  minDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                />
                <p className="form-error">{formErrors?.endDate}</p>
              </div>
            </div>
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Additional Info</label>
                <textarea
                  className="form-control"
                  placeholder="Enter your notes here"
                  name="additionalInfo"
                  value={formValues?.additionalInfo}
                  onChange={HandleFormChange}
                  rows="5"
                ></textarea>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn cancel-btn"
            onClick={handleCancelNewProject}
          >
            {" "}
            Cancel{" "}
          </button>
          <button
            type="button"
            className="btn continue-btn"
            disabled={disabledSubmit}
            onClick={HandleFormSubmit}
          >
            Continue
          </button>
        </Modal.Footer>
      </Modal>
      <SaveSuccessModel
        createMsg={createMsg}
        setCreateMsg={setCreateMsg}
        setShow={setShow}
        show={show}
        SuccessDoneClick={SuccessDoneClick}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
    </div>
  );
}
